module.exports = __webpack_public_path__ + "static/media/img009.30e76af1.jpg";